if (!customElements.get('image-zoom-modal')) {
  class ZoomModal extends HTMLElement {
    constructor() {
      super();
      this.selector = this.dataset.imageWrapperSelector;
      this.isOpen = false;
      this.media = [];
    }

    connectedCallback() {
      if (this.closest('main')) document.body.insertBefore(this, document.body.firstChild);

      document.addEventListener('click', e => {
        const image_container = e.target.closest('[data-image-container]');
        if (!image_container) return;

        if (window.innerWidth > 768) return;
        e.stopImmediatePropagation();

        const containers = document.querySelectorAll('li[data-image-container]');
        const filtered = Array.from(containers).filter(el => !el.classList.contains('slider-image-hidden'));

        this.media.length = 0;
        const seen = new Set();

        filtered.forEach(el => {
          const media = el.querySelector('img, video');
          if (!media) return;

          let src = '';
          if (media.tagName === 'VIDEO') {
            src = media.currentSrc || media.src || (media.querySelector('source') ? media.querySelector('source').src : '');
          } else {
            src = media.currentSrc || media.src;
          }
          if (!src) return;

          const key = src.replace(/([?&])width=\d+\b/g, '');
          if (seen.has(key)) return;
          seen.add(key);

          media.setAttribute('data-image-index', this.media.length);
          this.media.push(media);
        });

        if (!this.isOpen) {
          this.triggerImage = image_container.querySelector('img, video') || e.target;
          this.open();
        }
      });
    }

    close() {
      this.style.display = null;
      this.style.position = null;
      this.style.height = null;
      this.style.width = null;
      this.style.zIndex = null;
      this.isOpen = false;
      this.innerHTML = '';
      document.body.classList.remove('sparky-overlay');
    }

    open() {
      const starting_index = this.triggerImage.getAttribute('data-image-index');
      this.isOpen = true;

      document.body.classList.add('sparky-overlay');
      document.body.classList.remove('!sp-overflow-auto');

      this.innerHTML = `
        <div class="sp-relative sp-w-full sp-h-full sp-text-black sp-bg-white">
          <button data-close-button type="button" aria-label="close modal" class="sp-absolute sp-bg-white sp-text-black sp-top-0 sp-right-0 sp-p-7 sp-flex sp-items-center sp-transition sp-duration-200 sp-z-10 sp-animation-spin">
            <div class="sp-w-6 sp-h-6">
              <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="currentColor" viewBox="0 0 12 12">
                <path d="M10.795 0 6 4.795 1.2 0 0 1.2 4.795 6 0 10.795 1.2 12 6 7.205 10.795 12 12 10.795 7.205 6 12 1.2z"/>
              </svg>
            </div>
          </button>
          <swiper-image-gallery class="sp-flex sp-h-full" data-starting-index="${starting_index || 0}" data-slide-count="${this.media.length}">
            <div class="sp-w-full sp-h-full sp-flex sp-justify-center sp-items-center">
              <div class="sp-h-full sp-flex sp-items-center sp-overflow-hidden">
                <swiper-container
                  initial-slide="${starting_index || 0}"
                  data-gallery
                  zoom="true"
                  class="sp-cursor-zoom-in sp-w-full"
                  navigation-next-el="#next-zoom-modal"
                  navigation-prev-el="#prev-zoom-modal"
                >
                  ${this.media.map((media) => {
                    if (media.tagName === 'VIDEO') {
                      const src = media.currentSrc || media.src || (media.querySelector('source') ? media.querySelector('source').src : '');
                      const poster = media.getAttribute('poster') || '';
                      return `
                        <swiper-slide>
                          <div data-zoom-container class="swiper-zoom-container">
                            <video class="sp-block sp-w-full sp-h-full sp-object-center sp-object-contain" playsinline muted autoplay controls ${poster ? `poster="${poster}"` : ''}>
                              <source src="${src}">
                            </video>
                          </div>
                        </swiper-slide>
                      `;
                    } else {
                      const raw = media.currentSrc || media.src;
                      const upgraded = raw.replace(/([?&])width=\d+\b/, '$1width=2400');
                      const alt = media.alt || '';
                      return `
                        <swiper-slide>
                          <div data-zoom-container class="swiper-zoom-container">
                            <img class="sp-block sp-w-full sp-h-full sp-object-center sp-object-contain" loading="lazy" height="2400" width="2400" alt="${alt}" src="${upgraded}" />
                          </div>
                        </swiper-slide>
                      `;
                    }
                  }).join('')}
                </swiper-container>
              </div>
            </div>

            ${this.media.length > 1 ? `
              <div class="sp-flex sp-items-center sp-w-max sp-gap-8 sp-left-1/2 sp-transform -sp-translate-x-1/2 sp-absolute sp-bottom-0 sp-z-20 sp-px-5 sp-py-8">
                <button id="prev-zoom-modal" class="disabled:sp-opacity-20 hover:enabled:sp-text-accent1 sp-p-5 sp-bg-white sp-text-black" aria-label="previous slide" data-prev>
                  <span class="sp-block sp-w-7 sp-h-6 sp-transform sp-rotate-180">
                    <svg xmlns="http://www.w3.org/2000/svg" data-name="Group 490" width="100%" height="100%" viewBox="0 0 8 14">
                      <defs>
                        <clipPath id="dpuo5a2tba">
                        <path data-name="Rectangle 50" d="M0 0h8v14H0z"/>
                        </clipPath>
                      </defs>
                      <path fill="currentColor" data-name="Path 23" d="M1.351 14 0 12.658 5.693 7 0 1.342 1.351 0 7.72 6.329a.945.945 0 0 1 0 1.342z" style="clip-path:url(#dpuo5a2tba)"/>
                    </svg>
                  </span>
                </button>
                <div data-pagination></div>
                <button id="next-zoom-modal" class="disabled:sp-opacity-20 hover:enabled:sp-text-accent1 sp-p-5 sp-bg-white sp-text-black" aria-label="next slide" data-next>
                  <span class="sp-block sp-w-7 sp-h-6">
                    <svg xmlns="http://www.w3.org/2000/svg" data-name="Group 490" width="100%" height="100%" viewBox="0 0 8 14">
                      <defs>
                        <clipPath id="dpuo5a2tba">
                          <path data-name="Rectangle 50" d="M0 0h8v14H0z"/>
                        </clipPath>
                      </defs>
                      <path fill="currentColor" data-name="Path 23" d="M1.351 14 0 12.658 5.693 7 0 1.342 1.351 0 7.72 6.329a.945.945 0 0 1 0 1.342z" style="clip-path:url(#dpuo5a2tba)"/>
                    </svg>
                  </span>
                </button>
              </div>
            ` : ''}
          </swiper-image-gallery>
        </div>
      `;

      this.style.display = 'block';
      this.style.position = 'fixed';
      this.style.height = '100%';
      this.style.width = '100%';
      this.style.zIndex = '10000';

      const close_button = this.querySelector('[data-close-button]');

      close_button.addEventListener('click', () => {
        this.close();
      });
    }
  }

  customElements.define('image-zoom-modal', ZoomModal);
}
